import "./loader.css";

export default function ImageLoader() {
  return (
    <div className="image-loader-container">
      <div className="image-loader"></div>
    </div>
  );
}
